import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react'

/**
 * Sortable column header. Click to toggle asc → desc → none.
 */
export default function SortHeader({ label, sortKey, currentKey, currentDir, onSort, className = '', align = 'left' }) {
  const isActive = currentKey === sortKey
  const alignCls = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start'

  return (
    <th
      className={`px-4 py-3 font-medium cursor-pointer select-none group hover:bg-gray-100 transition-colors ${className}`}
      onClick={() => onSort(sortKey)}
    >
      <div className={`flex items-center gap-1 ${alignCls}`}>
        <span>{label}</span>
        <span className={`transition-opacity ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-40'}`}>
          {isActive && currentDir === 'asc' && <ChevronUp className="h-3.5 w-3.5" />}
          {isActive && currentDir === 'desc' && <ChevronDown className="h-3.5 w-3.5" />}
          {!isActive && <ChevronsUpDown className="h-3.5 w-3.5" />}
        </span>
      </div>
    </th>
  )
}
